module.exports = __webpack_public_path__ + "img/overlay_new_mobile.3e4d0370.svg";